import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import EditProfile from './components/Profile/Editor';

import logo from './assets/img/logo.png'
import profile from './assets/img/profile.png'

import { isBrowser } from "react-device-detect";

const styles = theme => ({
    appBar: {
        position: 'fixed',
        // zIndex: 2000
    },
    toolbarTitle: {
        flex: 1,
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    }
});



class App extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { anchorEl: null }
    }

    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {
        const { classes } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        const user = JSON.parse(sessionStorage.getItem('user'));
        console.log(user)
        return (
            user && user.userName ? <AppBar position="static" color="default" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="title" color="inherit" noWrap className={classes.toolbarTitle}>
                        {isBrowser ? <Link to="/" style={{ textDecoration: 'none', color: 'black' }}><img src={logo} alt="logo" ></img></Link> : undefined}
                    </Typography>
                    <div>

                        <Link to="/news" style={{ textDecoration: 'none', color: 'black' }}><Button color="inherit">ประกาศ</Button></Link>
                        <Link to="/courses" style={{ textDecoration: 'none', color: 'black' }}><Button color="inherit">คอร์สเรียนทั้งหมด</Button></Link>
                        <Link to="/mycourse" style={{ textDecoration: 'none', color: 'black' }}><Button color="primary">คอร์สเรียนของฉัน</Button></Link>

                        <IconButton
                            aria-owns={open ? 'menu-appbar' : null}
                            aria-haspopup="true"
                            onClick={this.handleMenu}
                            color="inherit"
                        >
                            <Avatar alt="Remy Sharp" src={profile} />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onClose={this.handleClose}
                        >
                            <EditProfile user={user} onClickProfile={() => this.handleClose()} />
                            {/* {user.userName === "admin" ? <MenuItem onClick={this.handleClose}><Link to="/courseManager" style={{ textDecoration: 'none', color: 'black' }}>จัดการคอร์สเรียน</Link></MenuItem> : undefined}
                            {user.userName === "admin" ? <MenuItem onClick={this.handleClose}><Link to="/userManager" style={{ textDecoration: 'none', color: 'black' }}>จัดการผู้ใช้งาน</Link></MenuItem> : undefined} */}
                            {isBrowser && user.userName === "admin" ? <Link to="/settings" style={{ textDecoration: 'none', color: 'black' }}><MenuItem onClick={this.handleClose}>ตั้งค่า</MenuItem></Link> : undefined}
                            <MenuItem onClick={() => {
                                this.setState({ anchorEl: null })
                                sessionStorage.removeItem('user')
                                this.props.history.push('/login')
                            }}>ออกจากระบบ</MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar> : <div></div>
        );
    }
}

export default withStyles(styles)(App);
